import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';

// Firebase configuration - Replace with your own
const firebaseConfig = {
  apiKey: "AIzaSyDqFIQ8NmgFNLH47EOtqTpj7eaE5JJxMjE",
  authDomain: "ozia-8c025.firebaseapp.com",
  databaseURL: "https://ozia-8c025-default-rtdb.firebaseio.com",
  projectId: "ozia-8c025",
  storageBucket: "ozia-8c025.firebasestorage.app",
  messagingSenderId: "465548290797",
  appId: "1:465548290797:web:ca119a2f988cf3f4017ae4",
  measurementId: "G-5L568JYCY6"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const database = getDatabase(app);